"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _airbnbPropTypes = require("airbnb-prop-types");
var _propTypes2 = require("@agillic/prop-types");
var _spinnerContainer = _interopRequireDefault(require("../spinnerContainer/spinnerContainer.presenter"));
var _iconContainer = _interopRequireDefault(require("../iconContainer/iconContainer.presenter"));
var _dropdownContainer = require("./dropdownContainer.helper");
var _mergeInputField = require("../mergeInputField.shapes");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var getStyleProps = function getStyleProps(_ref) {
  var isPaginated = _ref.isPaginated,
    isSmall = _ref.isSmall,
    pageSize = _ref.pageSize;
  return {
    style: isPaginated ? {
      maxHeight: (0, _dropdownContainer.calculateMaxHeight)({
        isSmall: isSmall,
        pageSize: pageSize
      })
    } : undefined
  };
};
var DropdownContainer = function DropdownContainer(props) {
  var isDropdownVisible = props.isDropdownVisible,
    locale = props.locale,
    results = props.results,
    hasPromotionFieldResults = props.hasPromotionFieldResults,
    hasLookupFieldResults = props.hasLookupFieldResults,
    instruction = props.instruction,
    highlightedIndex = props.highlightedIndex,
    highlightedItem = props.highlightedItem,
    uniqueID = props.uniqueID,
    isPromotionSelected = props.isPromotionSelected,
    isLookupSelected = props.isLookupSelected,
    selectedItem = props.selectedItem,
    isPaginated = props.isPaginated,
    pageSize = props.pageSize,
    onScrollToBottom = props.onScrollToBottom,
    isSpinnerVisible = props.isSpinnerVisible,
    isSmall = props.isSmall,
    numberOfItemsInDropdown = props.numberOfItemsInDropdown,
    setDropdownReference = props.setDropdownReference,
    setPivotReferences = props.setPivotReferences;
  var arePropositionResultsVisible = (0, _dropdownContainer.getParentFieldsResultsVisibility)({
    isParentSelected: isPromotionSelected,
    selectedItem: selectedItem
  });
  var areLookupResultsVisible = (0, _dropdownContainer.getParentFieldsResultsVisibility)({
    isParentSelected: isLookupSelected,
    selectedItem: selectedItem
  });
  var showDropdown = (0, _dropdownContainer.shouldShowDropdown)({
    isDropdownVisible: isDropdownVisible,
    isPromotionSelected: isPromotionSelected,
    isLookupSelected: isLookupSelected,
    selectedItem: selectedItem
  });
  return _react.default.createElement(_react.Fragment, null, showDropdown && _react.default.createElement("div", {
    className: "instruction"
  }, (0, _dropdownContainer.getInstructionToShow)({
    hasPromotionFieldResults: hasPromotionFieldResults,
    hasLookupFieldResults: hasLookupFieldResults,
    arePropositionResultsVisible: arePropositionResultsVisible,
    areLookupResultsVisible: areLookupResultsVisible,
    results: results,
    locale: locale,
    instruction: instruction
  })), _react.default.createElement("div", _extends({
    "data-testid": "resultsContainer",
    ref: function ref(dropdown) {
      return setDropdownReference(dropdown);
    },
    className: (0, _classnames.default)('resultsContainer', {
      visible: showDropdown
    })
  }, getStyleProps({
    isPaginated: isPaginated,
    isSmall: isSmall,
    pageSize: pageSize
  }), {
    onScroll: function onScroll(_ref2) {
      var _ref2$target = _ref2.target,
        offsetHeight = _ref2$target.offsetHeight,
        scrollTop = _ref2$target.scrollTop,
        scrollHeight = _ref2$target.scrollHeight;
      return !isSpinnerVisible && !(0, _dropdownContainer.didReachLastPage)({
        numberOfItemsInDropdown: numberOfItemsInDropdown,
        pageSize: pageSize,
        results: results
      }) && (0, _dropdownContainer.onScrollHandler)({
        isPaginated: isPaginated,
        pageSize: pageSize,
        onScrollToBottom: onScrollToBottom,
        didHitBottom: (0, _dropdownContainer.didHitBottom)({
          offsetHeight: offsetHeight,
          scrollTop: scrollTop,
          scrollHeight: scrollHeight
        })
      })(uniqueID);
    }
  }), results.map(function (_ref3, index) {
    var title = _ref3.title,
      sourceType = _ref3.sourceType;
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      _react.default.createElement("div", {
        key: "".concat(title, "-").concat(sourceType),
        "data-testid": "result_".concat(index),
        ref: function ref(element) {
          return setPivotReferences(element, index);
        },
        className: (0, _classnames.default)('result', {
          highlighted: index === highlightedIndex
        }),
        role: "button",
        tabIndex: "-1",
        onMouseMove: function onMouseMove() {
          return (0, _dropdownContainer.onMouseMoveHandler)(_objectSpread({}, props, {
            index: index
          }))(uniqueID);
        },
        onMouseDown: function onMouseDown(event) {
          return event.preventDefault();
        },
        onClick: function onClick() {
          return (0, _dropdownContainer.onDropdownClickHandler)(_objectSpread({}, props, {
            highlightedItem: highlightedItem
          }))(uniqueID);
        }
      }, _react.default.createElement(_iconContainer.default, {
        sourceType: sourceType,
        locale: locale
      }), _react.default.createElement("div", {
        className: "titleContainer"
      }, _react.default.createElement("div", {
        className: "title"
      }, title)))
    );
  }), isSpinnerVisible && _react.default.createElement(_spinnerContainer.default, null)));
};
DropdownContainer.propTypes = {
  isDropdownVisible: _propTypes.bool,
  isPromotionSelected: _propTypes.bool,
  isLookupSelected: _propTypes.bool,
  hasPromotionFieldResults: _propTypes.bool.isRequired,
  hasLookupFieldResults: _propTypes.bool.isRequired,
  locale: _mergeInputField.localeShape.isRequired,
  instruction: _propTypes.string,
  results: (0, _propTypes.arrayOf)(_mergeInputField.dataShape),
  highlightedIndex: _propTypes.number,
  highlightedItem: _mergeInputField.dataShape,
  uniqueID: _propTypes.string.isRequired,
  types: (0, _propTypes.arrayOf)(_propTypes.string).isRequired,
  selectedItem: (0, _propTypes.shape)({
    sourceType: _propTypes.string.isRequired
  }),
  isPaginated: _propTypes.bool,
  pageSize: (0, _airbnbPropTypes.and)([_propTypes.number, (0, _airbnbPropTypes.between)({
    gte: 5
  }), (0, _propTypes2.requiredBy)('pagination')]),
  onScrollToBottom: (0, _airbnbPropTypes.and)([_propTypes.func, (0, _propTypes2.requiredBy)('pagination')]),
  isSpinnerVisible: _propTypes.bool,
  isSmall: _propTypes.bool,
  numberOfItemsInDropdown: (0, _airbnbPropTypes.and)([_propTypes.number, (0, _propTypes2.requiredBy)('pagination')]),
  setDropdownReference: _propTypes.func.isRequired,
  setPivotReferences: _propTypes.func.isRequired
};
var _default = DropdownContainer;
exports.default = _default;